import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import { withT } from "services/translation/";

import { Row } from "react-bootstrap";

import { Link } from "react-router-dom";

import Icon from "components/Icons/Icon";

import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";

import UserInvite from "components/Enterprise/UserManagement/UserInvite/";
import UserList from "components/Enterprise/UserManagement/UserList/";

function UserManagement({
  t,
  enterprise,
  site,
  group,
  sudoSiteId,
  siteName,
  onBackToOverview
}) {
  const [originType, setOriginType] = useState(enterprise ? "enterprise" : (site.enterprise_id ? "enterprise" : "company"));
  const [originId, setOriginId] = useState(enterprise ? enterprise.id : (site.enterprise_id || site.company_id));

  useEffect(() => {
    // if we're an enterprise user, then type is 'enterprise',
    // but if we're here from single site (i.e. we aren't in an enterprise), 
    // the site itself will have either an enterprise_id or a company_id
    setOriginType(enterprise ? "enterprise" : (site.enterprise_id ? "enterprise" : "company"));
    setOriginId(enterprise ? enterprise.id : (site.enterprise_id || site.company_id));
  }, [enterprise, sudoSiteId]);

  return (
    <div>
      <Row className="px-2 mt-2 mb-3">
        <div className="btn btn-default border-none side-pane-back text-dark">
          <Link to="#" onClick={onBackToOverview}>
            <span className="back-to-overview"><Icon className="fas fa-chevron-left mr-2" /> {t("back_to_overview")}</span>
          </Link>
        </div>
      </Row>
      <div>
        <UserInvite
          origin="SiteView"
          group={group}
          sudoSiteId={sudoSiteId}
          siteName={siteName}
          originType={originType}
          originId={originId}
        />
      </div>
      <div>
        <UserList
          origin="SiteView"
          site={site}
          group={group}
          sudoSiteId={sudoSiteId}
          siteName={siteName}
          originType={originType}
          originId={originId}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    enterprise: getEnterpriseFromRoute(state, props),
  };
};

export default withT(
  connect(mapStateToProps)(UserManagement),
  "site_overview.side_pane.user_management"
);